import React from "react"
import "./frames.css"

const SerieSigma = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">
        Sigma Series: Definiendo el Estándar de Innovación y Seguridad en
        Cámaras Hiperbáricas
      </h1>
      <section className="frames-section">
        <h2 className="frames-subtitle">Innovación y Calidad en Diseño</h2>
        <h3 className="frames-subsection">
          Visualización Perfecta con Metacrilato de Alta Calidad
        </h3>
        <p className="frames-text">
          Nuestras cámaras monoplaza de la serie Sigma son líderes en su
          categoría, fabricadas con metacrilato cilíndrico Blanson de 360º, que
          es reconocido en la industria por su robustez inigualable y capacidad
          para ofrecer una visión sin deformaciones. Cada cámara se mantiene
          firmemente sellada con cuatro tirantes de acero de alta resistencia.
        </p>

        <h3 className="frames-subsection">Construcción Excepcional</h3>
        <p className="frames-text">
          Fabricadas con aluminio y metacrilato de alta resistencia, estas
          cámaras son duraderas y confiables, preparadas para cualquier
          escenario.
        </p>
      </section>
      <section className="frames-section">
        <h2 className="frames-subtitle">Funcionalidades de Alta Tecnología</h2>
        <h3 className="frames-subsection">Comunicación Clara y Segura</h3>
        <p className="frames-text">
          Equipadas con un sistema de intercomunicación bidireccional diseñado
          específicamente para entornos hiperbáricos y con oxígeno, nuestras
          cámaras garantizan una comunicación segura e ininterrumpida con los
          pacientes. Este sistema de comunicación de vanguardia también incluye
          baterías de seguridad para garantizar su funcionamiento incluso en
          caso de interrupción del suministro eléctrico.
        </p>

        <h3 className="frames-subsection">Control de Precisión</h3>
        <p className="frames-text">
          La operación bajo una presión máxima de 3 ATA (30 psig) se ve
          facilitada por un panel de control neumático de serie que no consume
          electricidad, y un control de presiones semi-automático.
        </p>

        <h3 className="frames-subsection">Conexiones Personalizadas</h3>
        <p className="frames-text">
          Las conexiones in/out en la puerta permiten la utilización de
          monitorización avanzada, administración de medicamentos y equipamiento
          adicional, como el Sistema Air Break y sistemas especializados para la
          atención de pacientes críticos.
        </p>
      </section>
      <section className="frames-section">
        <h2 className="frames-subtitle">Confort y Accesibilidad</h2>
        <ul className="frames-list">
          <li>
            Configuración de Mano Selectiva: Opciones de apertura de puerta para
            mano derecha o izquierda.
          </li>
          <li>
            Ventilación Continua: Posibilidad de ajustar el modo de
            mantenimiento del 100% de oxígeno, permitiendo el control de la
            temperatura interior.
          </li>
        </ul>
      </section>
      <section className="frames-section">
        <h2 className="frames-subtitle">Conveniencia y Seguridad</h2>
        <h3 className="frames-subsection">Facilidad de Movimiento</h3>
        <p className="frames-text">
          Los equipos están montados sobre ruedas resistentes y giratorias, lo
          que facilita su maniobrabilidad en esquinas y pasillos, y su acceso a
          través de puertas de tamaño estándar.
        </p>

        <h3 className="frames-subsection">Características de Seguridad</h3>
        <ul className="frames-list">
          <li>
            Cierre de Puerta Único: Diseñado para una apertura rápida y segura.
          </li>
          <li>
            Contador de Ciclos Inviolable: Para un seguimiento preciso del uso.
          </li>
          <li>
            Pulsera Anti-Estática de Seguridad: Para garantizar una operación
            segura.
          </li>
        </ul>
      </section>
      <section className="frames-section">
        <h2 className="frames-subtitle">
          Opciones de Entretenimiento y Personalización
        </h2>
        <ul className="frames-list">
          <li>
            Instalación para Sistema de Entretenimiento: Para una experiencia
            del paciente más agradable.
          </li>
          <li>
            Sistemas Adaptables: Elija entre diversas configuraciones como
            SISTEMA BIBS, SISTEMA ELITE, SISTEMA UNDERCARRIAGE y SISTEMA DE
            ENTRETENIMIENTO COMPLETO.
          </li>
        </ul>
      </section>
      <section className="frames-section">
        <h2 className="frames-subtitle">Garantía y Servicio Postventa</h2>
        <p className="frames-text">
          Nos enorgullece ofrecer una garantía completa de dos años en cada
          cámara de la serie Sigma, respaldando así nuestra dedicación a la
          calidad y la innovación.
        </p>
      </section>
      <footer className="frames-footer">
        <p className="frames-text">
          Elija la Serie Sigma para una experiencia hiperbárica segura,
          innovadora y altamente eficaz.
        </p>
      </footer>{" "}
      <br />
      <br />
    </div>
  )
}

export default SerieSigma
